/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Value } from './Value';
import { ValueFromJSON, ValueFromJSONTyped, ValueToJSON } from './Value';

/**
 * Represents a single filter condition.
 * @export
 * @interface FilterCondition
 */
export interface FilterCondition {
  /**
   * The field to filter on.
   * @type {string}
   * @memberof FilterCondition
   */
  field: string;
  /**
   * The comparison operator. e.g. '=', '>', '~=' for regex
   * @type {string}
   * @memberof FilterCondition
   */
  op: FilterConditionOpEnum;
  /**
   *
   * @type {Value}
   * @memberof FilterCondition
   */
  value: Value;
}

/**
 * @export
 */
export const FilterConditionOpEnum = {
  Equal: '=',
  TildeEqual: '~=',
  NotEqual: '!=',
  GreaterThan: '>',
  LessThan: '<',
  GreaterThanOrEqualTo: '>=',
  LessThanOrEqualTo: '<=',
} as const;
export type FilterConditionOpEnum =
  (typeof FilterConditionOpEnum)[keyof typeof FilterConditionOpEnum];

/**
 * Check if a given object implements the FilterCondition interface.
 */
export function instanceOfFilterCondition(
  value: object,
): value is FilterCondition {
  if (!('field' in value) || value['field'] === undefined) return false;
  if (!('op' in value) || value['op'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function FilterConditionFromJSON(json: any): FilterCondition {
  return FilterConditionFromJSONTyped(json, false);
}

export function FilterConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FilterCondition {
  if (json == null) {
    return json;
  }
  return {
    field: json['field'],
    op: json['op'],
    value: ValueFromJSON(json['value']),
  };
}

export function FilterConditionToJSON(value?: FilterCondition | null): any {
  if (value == null) {
    return value;
  }
  return {
    field: value['field'],
    op: value['op'],
    value: ValueToJSON(value['value']),
  };
}
